import React, { useEffect, useState } from "react";
import { Field, useFormik } from "formik";
import * as Yup from "yup";
import "./PayOut.css";
import Select from "react-select";
import "react-phone-input-2/lib/style.css";
import { payoutInitiate } from "../../../config/LiveApi";
import { toast } from "react-toastify";
import OverLoad from "./OverLoad";
import * as XLSX from "xlsx";
import { useSelector } from "react-redux";

const phoneRegExp =
  /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;

export const signUpSchema = Yup.object({
  // bene_bank_name: Yup.string().min(2).required("Please enter Bank Name"),
  amount: Yup.string().required("Please enter Amount"),
  commission: Yup.string().required("Please enter Commission"),

  bene_name: Yup.string().required("Please enter Name"),
  bene_acc: Yup.string().required("Please enter Account No"),
  bene_ifsc: Yup.string().required("Please enter Ifsc Code"),
  // bene_bank_name: Yup.string().required("Please enter Bank Name"),
  // bene_branch_name: Yup.string().required("Please enter Branch Name"),
  // bene_email: Yup.string().required("Please enter Email"),
  bene_address: Yup.string().required("Please enter Address"),
  createdAt: Yup.date().required("Please select Created At date"),
  // bene_mobile: Yup.string()
  //   .max(10, "Phone number must be 10 digits")
  //   .min(10, "Phone number must be atleast 10 digits")
  //   .matches(phoneRegExp, "Phone number is not valid"),

  // remarks: Yup.string().required("Please enter your Remarks"),
});

function FormHaeder({ setTypeError, setExcelFile, setExcelData, listofusers, totalPages }) {
  const [selectedOptions, setSelectedOptions] = useState("");
  const [typeValue, setTypeValue] = useState("");
  const [modeSelected, setModeSelected] = useState("");
  const [modeValue, setModeValue] = useState("");
  const [startLoading, setStartLoading] = useState(false);
  let [totalOptions, setTotalOptions] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const token = useSelector(state => state.userReducer.token)

  useEffect(() => {
    const myData = [];


    listofusers?.map((item) => {

      myData.push({ value: item.id, label: item?.alias ||item?.id })
    })


    setTotalOptions(myData);
  }, [totalPages]);
const initialValues = {
  bene_bank_name: "State Bank of India",
  amount: "",
  bene_name: "Direct Entry",
  bene_acc: "123456789012",
  bene_ifsc: "SBIN0001234",
  bene_branch_name: "Delhi Branch",
  bene_email: "testuser@gmail.com",
  bene_mobile: "9876543210",
  bene_acc_type: typeValue,
  mode: modeValue,
  bene_address: "Delhi, India",
  createdAt: "",
  commission: "",
  remarks: "Direct Payout transaction",
};

  const { values, errors, touched, handleBlur, handleChange, handleSubmit } =
    useFormik({
      initialValues,
      validationSchema: signUpSchema,
      onSubmit: (values, action) => {
        (values.mode = modeValue), (values.bene_acc_type = typeValue);

        console.log(
          "🚀 ~ file: Registration.jsx ~ line 11 ~ Registration ~ values",
          values
        );
        // fetchUserIntegrations();
        callApi(values, token);
        action.resetForm();
      },
    });

  // const fetchUserIntegrations = async () => {
  //   try {
  //     const response = await get(`/v1/admin/users/integrations`);
  //     console.log(response?.data);
  //     setUserIntegrationsData(response?.data[0]);
  //     rotateApiKey(response?.data[0]);

  //   } catch (error) {
  //     console.log(error.message);
  //   }
  // };

  const callApi = async (values, token) => {
    setStartLoading(true);

    let formData = {
      amount: values.amount,
      mode: values.mode,
      ifscCode: values.bene_ifsc,
      branchname: values.bene_branch_name,
      accountNo: values.bene_acc,
      beneName: values.bene_name,
      beneAddress: values.bene_address,
      beneBankName: values.bene_bank_name,
      beneEmail: values.bene_email,
      // merchantReferenceNumber: "121211",
      commission: values.commission,
      beneMobile: values.bene_mobile,
      createdAt: values.createdAt,
      // "pg": "cube-pe"
    };

    console.log("data from fornm", formData);

    const data = await payoutInitiate(formData, token, selectedUser);
    console.log("datata", data);
    if (data) {
      toast.info(data.RESPONSE_MESSAGE);
    } else {
      toast.error("Some issue occured");
    }

    setStartLoading(false);
  };
  //   console.log("itemmmmmmmmmm", item);
  //   if (role == "super") {
  //     try {
  //       const response = await patch(
  //         `/v1/admin/users/x${item?.user?.id}/rotate`
  //       );
  //       console.log(response);
  //       setApiKey(response?.apiKey);
  //     } catch (error) {
  //       console.log(error.message);
  //     }
  //   } else {
  //     let body = {
  //       user: item.user,
  //     };
  //     try {
  //       const response = await patch(`/v1/admin/users/rotate`, body);
  //       console.log("dataaaaaaaa", response);
  //       setApiKey(response?.apiKey);
  //     } catch (error) {
  //       console.log(error.message);
  //     }
  //   }
  // };

  const myChange = (e) => {
    console.log("e.value", e);
    setSelectedOptions(e);
    setTypeValue(e.value);
  };
  const myChange2 = (e) => {
    console.log("e.value", e);
    setModeSelected(e);
    setModeValue(e.value);
  };

  const options = [
    { value: "IMPS", label: "IMPS" },
    { value: "NEFT", label: "NEFT" },
    { value: "RTGS", label: "RTGS" },
  ];
  const accountOptions = [
    { value: "CURRENT", label: "CURRENT" },
    { value: "SAVING", label: "SAVING" },
  ];

  const handleFile = (e) => {
    let fileTypes = [
      "application/vnd.ms-excel",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "text/csv",
    ];
    let selectedFile = e.target.files[0];
    if (selectedFile) {
      if (selectedFile && fileTypes.includes(selectedFile.type)) {
        setTypeError(null);
        let reader = new FileReader();
        reader.readAsArrayBuffer(selectedFile);
        reader.onload = (e) => {
          setExcelFile(e.target.result);

          if (e.target.result) {
            const workbook = XLSX.read(e.target.result, { type: "buffer" });
            const worksheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[worksheetName];
            const data = XLSX.utils.sheet_to_json(worksheet);

            setExcelData(data);
          }
        };
      } else {
        setTypeError("Please select only excel file types");
        setExcelFile(null);
      }
    } else {
      console.log("Please select your file");
    }
  };

  return (
    <div>
      {startLoading ? (
        <OverLoad />
      ) : (
        <div>
          <div className="out-head">
            <h2 className="area-top-title-pay-out">Pay Out Form</h2>
            {/* <div className="buttons-side">
              <div class="file file--upload">
                <label for="input-file">Bulk Payout</label>
                <input
                  id="input-file"
                  type="file"
                  value=""
                  onChange={handleFile}
                />
              </div>

              <div class="file file--upload">
                <label for="input-file">Download Sample</label>
                <input id="input-file" type="file" />
              </div>
            </div> */}
            <Select
              // value={{ value: currentPage, label: currentPage }}
              onChange={(e) => setSelectedUser(e.value)}
              options={totalOptions}
              className="hel-wide"
            />
          </div>

          <div>
            <form onSubmit={handleSubmit} className="">
              <div className="data-block">
                <div className="">
                  <label
                    htmlFor="bene_acc_type"
                    className="input-label text-base mb-2"
                  >
                    Account Type <span className="astrisk">*</span>
                  </label>

                  <div className="select-height">
                    <Select
                      name="bene_acc_type"
                      className="input-field-select"
                      value={selectedOptions}
                      styles={{
                        height: "4rem",
                      }}
                      onChange={myChange}
                      options={accountOptions}
                    />
                  </div>
                  {/* {errors.bene_acc_type && touched.bene_acc_type ? (
                    <p className="form-error">{errors.bene_acc_type}</p>
                  ) : null} */}
                </div>
                <div className="">
                  <label htmlFor="mode" className="input-label text-base mb-2">
                    Transfer Mode <span className="astrisk">*</span>
                  </label>

                  <Select
                    name="mode"
                    className="input-field-select"
                    value={modeSelected}
                    onChange={myChange2}
                    options={options}
                  />
                  {errors.mode && touched.mode ? (
                    <p className="form-error">{errors.mode}</p>
                  ) : null}
                </div>
                <div className="">
                  <label
                    htmlFor="bene_bank_name"
                    className="input-label text-base mb-2"
                  >
                    Branch Name <span className="astrisk">*</span>
                  </label>
                  <input
                    type="text"
                    autoComplete="off"
                    className="input-field"
                    name="bene_branch_name"
                    placeholder="Bank Branch Name"
                    value={values.bene_branch_name}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                  {/* {errors.bene_branch_name && touched.bene_branch_name ? (
                    <p className="form-error">{errors.bene_branch_name}</p>
                  ) : null} */}
                </div>

                {/*Bank Name Section */}
                {/*Amount Section */}
              </div>

              <div className="data-block">
                <div className="">
                  <label
                    htmlFor="bene_bank_name"
                    className="input-label text-base mb-2"
                  >
                    Beneficiary Bank Name <span className="astrisk">*</span>
                  </label>
                  <input
                    type="text"
                    autoComplete="off"
                    className="input-field"
                    name="bene_bank_name"
                    placeholder="Beneficiary Bank Name"
                    value={values.bene_bank_name}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                  {/* {errors.bene_bank_name && touched.bene_bank_name ? (
                    <p className="form-error">{errors.bene_bank_name}</p>
                  ) : null} */}
                </div>
                <div className="">
                  <label
                    htmlFor="amount"
                    className="input-label text-base mb-2"
                  >
                    Amount <span className="astrisk">*</span>
                  </label>
                  <input
                    type="text"
                    autoComplete="off"
                    className="input-field"
                    name="amount"
                    id="amount"
                    placeholder="Amount"
                    value={values.amount}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                  {errors.amount && touched.amount ? (
                    <p className="form-error">{errors.amount}</p>
                  ) : null}
                </div>


 <div className="">
                  <label
                    htmlFor="commission"
                    className="input-label text-base mb-2"
                  >
                    Commission <span className="astrisk">*</span>
                  </label>
                  <input
                    type="text"
                    autoComplete="off"
                    className="input-field"
                    name="commission"
                    id="commission"
                    placeholder="Commission"
                    value={values.commission}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                  {errors.commission && touched.commission ? (
                    <p className="form-error">{errors.commission}</p>
                  ) : null}
                </div>
                {/*Remarks Section */}
                <div className="">
                  <label
                    htmlFor="bene_name"
                    className="input-label text-base mb-2"
                  >
                    Beneficiary Name <span className="astrisk">*</span>
                  </label>
                  <input
                    type="text"
                    autoComplete="off"
                    className="input-field"
                    name="bene_name"
                    placeholder=" Beneficiary Name"
                    value={values.bene_name}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                  {errors.bene_name && touched.bene_name ? (
                    <p className="form-error">{errors.bene_name}</p>
                  ) : null}
                </div>
              </div>

              <div className="data-block">
                <div className="">
                  <label
                    htmlFor="bene_acc"
                    className="input-label text-base mb-2"
                  >
                    Beneficiary A/C Number <span className="astrisk">*</span>
                  </label>
                  <input
                    type="text"
                    autoComplete="off"
                    className="input-field"
                    name="bene_acc"
                    placeholder="Account Number"
                    value={values.bene_acc}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                  {errors.bene_acc && touched.bene_acc ? (
                    <p className="form-error">{errors.bene_acc}</p>
                  ) : null}
                </div>

                <div className="">
                  <label
                    htmlFor="bene_ifsc"
                    className="input-label text-base mb-2"
                  >
                    IFSC Code <span className="astrisk">*</span>
                  </label>
                  <input
                    type="text"
                    autoComplete="off"
                    className="input-field"
                    name="bene_ifsc"
                    placeholder="IFSC Code"
                    value={values.bene_ifsc}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                  {errors.bene_ifsc && touched.bene_ifsc ? (
                    <p className="form-error">{errors.bene_ifsc}</p>
                  ) : null}
                </div>
                <div className="">
                  <label
                    htmlFor="bene_address"
                    className="input-label text-base mb-2"
                  >
                    Address <span className="astrisk">*</span>
                  </label>
                  <input
                    type="text"
                    autoComplete="off"
                    className="input-field"
                    name="bene_address"
                    id="amount"
                    placeholder="Address"
                    value={values.bene_address}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                  {errors.bene_address && touched.bene_address ? (
                    <p className="form-error">{errors.bene_address}</p>
                  ) : null}
                </div>
              </div>
              <div className="data-block">
                <div className="">
                  <label
                    htmlFor="bene_mobile"
                    className="input-label text-base mb-2"
                  >
                    Beneficiary Mobile Number <span className="astrisk">*</span>
                  </label>
                  <input
                    type="text"
                    autoComplete="off"
                    className="input-field"
                    name="bene_mobile"
                    placeholder="Beneficiary Mobile Number"
                    value={values.bene_mobile}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                  {/* {errors.bene_mobile && touched.bene_mobile ? (
                    <p className="form-error">{errors.bene_mobile}</p>
                  ) : null} */}
                </div>

                <div className="">
                  <label
                    htmlFor="bene_email"
                    className="input-label text-base mb-2"
                  >
                    Beneficiary Email <span className="astrisk">*</span>
                  </label>
                  <input
                    type="text"
                    autoComplete="off"
                    className="input-field"
                    name="bene_email"
                    placeholder="Beneficiary Email"
                    value={values.bene_email}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                  {errors.bene_email && touched.bene_email ? (
                    <p className="form-error">{errors.bene_email}</p>
                  ) : null}
                </div>

                <div className="">
                  <label
                    htmlFor="remarks"
                    className="input-label text-base mb-2"
                  >
                    Remarks <span className="astrisk">*</span>
                  </label>
                  <input
                    type="text"
                    autoComplete="off"
                    className="input-field"
                    name="remarks"
                    id="email"
                    placeholder="Remarks"
                    value={values.remarks}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                  {errors.remarks && touched.remarks ? (
                    <p className="form-error">{errors.remarks}</p>
                  ) : null}
                </div>
              </div>
              <div className="">
   <label htmlFor="createdAt" className="input-label text-base mb-2">
     Created At <span className="astrisk">*</span>
   </label>
   <input
     type="datetime-local"
     className="input-field"
     name="createdAt"
     value={values.createdAt}
     onChange={handleChange}
     onBlur={handleBlur}
   />
   {errors.createdAt && touched.createdAt ? (
     <p className="form-error">{errors.createdAt}</p>
   ) : null}
 </div>

              {/* ////////////////////////////////////////////////////////////////////////// */}

              <div className="sub-button">
                <button className="addUser-btn-1">Submit</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

export default FormHaeder;
